<script setup>

// 底部组件
const props = defineProps({
    common: {
        type: Object,
        required: false,
        default: () => { },
    },
    friend: {
        required: false,
        default: () => [],
    },
})


const mobileAccordion = reactive([
    {
        id: 1, title: `${props.common?.webname}计算`, img: '@/static/img/footer/itemimg1.png', content: [
            {
                title: '公司介绍',
                url: '/company.html'
            },
            {
                title: '荣誉资质',
                url: '/company.html'
            }
        ]
    },
    {
        id: 2, title: '行业解决方案', img: '@/static/img/footer/itemimg2.png', content: [
            {
                title: '网站解决方案',
                url: '/website.html'
            },
            {
                title: '游戏云解决方案',
                url: '/gamePlan.html'
            },
            {
                title: '金融云解决方案',
                url: '/finance.html'
            },
            {
                title: '电商云解决方案',
                url: '/ecommerce.html'
            },
            {
                title: '移动云解决方案',
                url: '/mobile.html'
            }
        ]
    },
    {
        id: 3, title: '帮助与支持', img: '@/static/img/footer/itemimg3.png', content: [
            {
                title: '账户问题',
                url: '/knowledgebase'
            },
            {
                title: '备案指南',
                url: '/knowledgebase'
            },
            {
                title: '常见问题',
                url: '/knowledgebase'
            },
            {
                title: '网站备案',
                url: '/knowledgebase'
            },
            {
                title: '工单服务',
                url: '/submitticket'
            }
        ]
    },
    {
        id: 4, title: '合作与生态', img: '@/static/img/footer/itemimg4.png', content: [
            {
                title: '代理合作',
                url: '/agent.html'
            },
            {
                title: 'CPS推广',
                url: '/cpsExtension.html'
            },
            {
                title: '官方公告',
                url: '/new_Smell.html?Class=1'
            },
            {
                title: '联系我们',
                url: '/company.html'
            },
            {
                title: '产品中心',
                url: '/cart'
            }
        ]
    },
    {
        id: 5, title: '管理与控制中心', img: '@/static/img/footer/itemimg5.png', content: [
            {
                title: '控制中心',
                url: '/clientarea'
            },
            {
                title: '安全中心',
                url: '/security'
            },
            {
                title: '资源中心',
                url: '/downloads'
            },
            {
                title: '财务管理',
                url: '/transaction'
            },
            {
                title: '账户信息',
                url: '/details'
            }
        ]
    },
])

// 判断是否是移动端
const initMobile = () => {
    return window.innerWidth < 768
}

// 提取警号
const policeNumber = (police) => {
    const match = police ? police.match(/\d+/) : null
    return match ? match[0] : ""
}
</script>

<template>

    <div class="Heziyun-whiteFooter">
        <div class="Heziyun-defaultWidth">
            <!-- 说明方块 -->
            <div class="Heziyun-explanationBlock">
                <div class="Heziyun-item">
                    <img src="@/static/img/footer/kuai1.svg" alt="">
                    <div class="Heziyun-text">
                        <span>{{ $t('index.footer25') }}</span>
                        <p>{{ $t('index.footer26') }}</p>
                    </div>
                </div>
                <div class="Heziyun-item">
                    <img src="@/static/img/footer/kuai2.svg" alt="">
                    <div class="Heziyun-text">
                        <span>{{ $t('index.footer27') }}</span>
                        <p>{{ $t('index.footer28') }}</p>
                    </div>
                </div>
                <div class="Heziyun-item">
                    <img src="@/static/img/footer/kuai3.svg" alt="">
                    <div class="Heziyun-text">
                        <span>{{ $t('index.footer29') }}</span>
                        <p>{{ $t('index.footer30') }}</p>
                    </div>
                </div>
                <div class="Heziyun-item">
                    <img src="@/static/img/footer/kuai4.svg" alt="">
                    <div class="Heziyun-text">
                        <span>{{ $t('index.footer31') }}</span>
                        <p>{{ $t('index.footer32') }}</p>
                    </div>
                </div>
            </div>

            <!-- 底部链接 - 联系我们 -->
            <div class="Heziyun-bottomMiddle">
                <div class="Heziyun-itemLink pc">
                    <span>{{ common?.webname }}{{ $t('index.footer1') }}</span>
                    <a href="/company.html">{{ $t('index.footer2') }}</a>
                    <a href="/company.html">{{ $t('index.footer3') }}</a>
                </div>

                <div class="Heziyun-itemLink pc">
                    <span>{{ $t('index.footer4') }}</span>
                    <a href="/website.html">{{ $t('index.solution3_3') }}</a>
                    <a href="/gamePlan.html">{{ $t('index.solution4') }}</a>
                    <a href="/finance.html">{{ $t('index.solution6') }}</a>
                    <a href="/ecommerce.html">{{ $t('index.solution7') }}</a>
                    <a href="/mobile.html">{{ $t('index.solution5') }}</a>
                </div>

                <div class="Heziyun-itemLink pc">
                    <span>{{ $t('index.footer5') }}</span>
                    <a href="/knowledgebase">{{ $t('index.footer6') }}</a>
                    <a href="/knowledgebase">{{ $t('index.footer7') }}</a>
                    <a href="/knowledgebase">{{ $t('index.footer8') }}</a>
                    <a href="/knowledgebase">{{ $t('index.footer9') }}</a>
                    <a href="/submitticket">{{ $t('index.footer10') }}</a>
                </div>
                <div class="Heziyun-itemLink pc">
                    <span>{{ $t('index.footer11') }}</span>
                    <a href="/agent.html">{{ $t('index.footer12') }}</a>
                    <a href="/cpsExtension.html">{{ $t('index.footer13') }}</a>
                    <a href="/new_Smell.html?Class=1">{{ $t('index.footer14') }}</a>
                    <a href="/company.html">{{ $t('index.footer15') }}</a>
                    <a href="/cart">{{ $t('index.footer16') }}</a>
                </div>
                <div class="Heziyun-itemLink pc">
                    <span>{{ $t('index.footer17') }}</span>
                    <a href="/clientarea">{{ $t('index.footer18') }}</a>
                    <a href="/security">{{ $t('index.footer19') }}</a>
                    <a href="/downloads">{{ $t('index.footer20') }}</a>
                    <a href="/transaction">{{ $t('index.footer21') }}</a>
                    <a href="/details">{{ $t('index.footer22') }}</a>
                </div>

                <div class="Heziyun-contactMy">
                    <div class="Heziyun-title">
                        <span>{{ $t('index.footer15') }}</span>
                        <p>{{ $t('index.footer33') }}：{{ common?.phone.split(',')[0].trim() }}</p>
                        <p class="Heziyun-friendship">
                            {{ $t('index.footer23') }}：
                            <a :href="item.url" target="_blank" v-for="item in friend" :key="item.id">《{{
                                item.title }}》</a>
                        </p>

                        <a-tooltip background-color="#fff">
                            <img :src="common?.wx" class="Heziyun-logo">
                            <template #content>
                                <img :src="common?.wx" class="Heziyun-logo2">
                            </template>
                        </a-tooltip>
                    </div>
                </div>

            </div>

            <a-collapse :default-active-key="[1]" accordion v-if="initMobile()" expand-icon-position="right">
                <template #expand-icon="{ active }">
                    <icon-up v-if="active" />
                    <icon-down v-else />
                </template>
                <a-collapse-item :header="item.title" :key="item.id" v-for="item in mobileAccordion">
                    <a :href="items.url" v-for="items in item.content" class="Heziyun-item">{{ items.title }}</a>
                </a-collapse-item>
            </a-collapse>


            <!-- 备案 -->
            <div class="Heziyun-bottom">
                <div class="Heziyun-copyright">
                    <p v-html="common?.copyright"></p>
                </div>
                <div class="Heziyun-keepOnRecord">
                    <a href="https://beian.miit.gov.cn/" target="_blank" v-if="common?.icp">
                        <img src="@/static/img/footer/keepOnRecord2.webp" alt="">
                        {{ common?.icp }}
                    </a>
                    <a v-if="common?.police"
                        :href="`https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${policeNumber(common?.police)}`"
                        target="_blank">
                        <img src="@/static/img/footer/keepOnRecord.webp" alt="">
                        {{ common?.police }}
                    </a>
                    <p v-if="common?.telecommunication">
                        <img src="@/static/img/footer/keepOnRecord.webp" alt="">{{ common?.telecommunication }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.arco-trigger-popup-wrapper,
.arco-trigger-arrow {
    border: 1px solid #ddd;
}

.arco-trigger-arrow {
    z-index: 1;
}
</style>

<style lang="less" scoped>
// 移动端链接
:deep(.arco-collapse-item-content-box) {
    font-size: 4vw;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}

:deep(.arco-collapse-item-content-box .Heziyun-item) {
    padding: 2.5vw 5vw;
    border-bottom: 1px solid #e0e0e0;
}

:deep(.arco-collapse-item-header) {
    background-color: transparent;
}

:deep(.arco-collapse-item-active > .arco-collapse-item-header) {
    background-color: #d8d8d8;
    border-radius: 1vw;
}

:deep(.arco-collapse-item-content) {
    background-color: transparent;
    padding: 0;
}

:deep(.arco-collapse) {
    border: none;
}

//  底部页脚（白色）
.Heziyun-whiteFooter {
    background-color: #f4f7fc;

    .Heziyun-defaultWidth {

        // 说明方块
        .Heziyun-explanationBlock {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 120px;
            border-bottom: 1px solid #dde2e9;

            .Heziyun-item {
                display: flex;
                align-items: center;
                gap: 0.6rem;

                img {
                    width: 3rem;
                    height: 3rem;
                }

                .Heziyun-text {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;

                    span {
                        color: #020814;
                        font-size: 1rem;
                        letter-spacing: .003em;
                    }
                }
            }
        }

        // 底部链接 - 联系我们
        .Heziyun-bottomMiddle {
            padding: 3rem 0;
            display: flex;
            border-bottom: 1px solid #dde2e9;
            gap: 10px;

            .Heziyun-itemLink {
                flex: 1 1 0%;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;

                span {
                    color: #020814;
                    font-size: 1rem;
                    font-weight: 500;
                    margin-bottom: 0.5rem;
                    padding: 0 0.6rem;
                    line-height: 1.7;
                }

                a {
                    color: #41464f;
                    font-size: 0.8rem;
                    width: fit-content;
                    padding: 0.3rem 0.6rem;
                    line-height: 1.5;

                    &:hover {
                        color: #0066CC;
                        background-color: #ffffff;
                    }
                }
            }

            .Heziyun-contactMy {
                flex: 2 1 0%;

                .Heziyun-title {
                    display: flex;
                    flex-direction: column;
                    gap: 0.8rem;

                    span {
                        font-size: 1rem;
                        margin-bottom: 0.5rem;
                        line-height: 1.7;
                    }

                    p {
                        color: #41464f;
                        font-size: 0.84rem;
                    }

                    .Heziyun-friendship {
                        color: #003f9e;

                        a {
                            &:hover {
                                color: #0066CC;
                            }
                        }
                    }

                    .Heziyun-logo {
                        width: 5rem;
                        height: 5rem;
                        object-fit: contain;
                        background-image: linear-gradient(0deg, #fff 0%, #f3f5f8 100%);
                        border: 2px solid #fff;
                        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1), -8px -8px 20px 0 #fff;
                        border-radius: 4px;
                    }
                }
            }
        }

        // 备案
        .Heziyun-bottom {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            padding: 2rem 0;

            .Heziyun-keepOnRecord {
                display: flex;
                align-items: center;
                gap: 1rem;

                a {
                    text-align: center;
                    color: #41464f;
                    font-size: 0.84rem;
                    display: flex;
                    align-items: center;
                    gap: 0.2rem;

                    img {
                        width: 1rem;
                        height: 1rem;
                    }

                    &:hover {
                        color: #0066CC;
                    }
                }

                p {
                    text-align: left;
                    color: #41464f;
                    font-size: 0.84rem;
                    display: flex;
                    align-items: center;
                    gap: 0.2rem;

                    img {
                        width: 0.9rem;
                        height: 0.9rem;
                    }
                }
            }

            .Heziyun-copyright {
                p {
                    text-align: left;
                    color: #41464f;
                    font-size: 0.84rem;
                    line-height: 1.7;
                }
            }
        }
    }
}

.Heziyun-logo2 {
    width: 8rem;
    height: 8rem;
    object-fit: contain;
}

//  底部页脚（白色）
@media (max-width: 768px) {
    .Heziyun-whiteFooter {
        background-color: #f4f7fc;

        .Heziyun-defaultWidth {

            // 说明方块
            .Heziyun-explanationBlock {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 5vw 0;
                height: auto;
                padding: 5vw 0;

                .Heziyun-item {
                    flex-direction: column;
                    gap: 3vw;

                    img {
                        width: 9vw;
                        height: 9vw;
                    }

                    .Heziyun-text {
                        gap: 2vw;

                        span {
                            font-size: 4vw;
                        }

                        p {
                            display: none;
                        }
                    }
                }
            }

            // 底部链接 - 联系我们
            .Heziyun-bottomMiddle {
                padding: 3vw 0;
                border-bottom: none;

                .Heziyun-contactMy {

                    .Heziyun-title {
                        display: flex;
                        flex-direction: column-reverse;
                        gap: 2vw;
                        justify-content: center;
                        align-items: center;

                        span {
                            display: none;
                        }

                        p {
                            font-size: 4vw;
                        }

                        .Heziyun-friendship {
                            color: #003f9e;

                            a {
                                &:hover {
                                    color: #0066CC;
                                }
                            }
                        }

                        .Heziyun-logo {
                            width: 30vw;
                            height: 30vw;
                        }
                    }
                }
            }

            // 备案
            .Heziyun-bottom {
                gap: 2vw;
                padding: 3vw 0;

                .Heziyun-keepOnRecord {
                    gap: 2vw;
                    flex-wrap: wrap;

                    a {
                        font-size: 3.5vw;
                        gap: 2vw;

                        img {
                            width: 5vw;
                            height: 5vw;
                        }
                    }

                    p {
                        font-size: 3.5vw;
                        gap: 2vw;


                        img {
                            width: 5vw;
                            height: 5vw;
                        }
                    }
                }

                .Heziyun-copyright {
                    p {
                        font-size: 3.5vw;
                    }
                }
            }
        }
    }
}
</style>